<template>
    <div class="asset--wrapper">
        <div class="asset__img">
            <span class="mono-numbers">{{imgSrc}}</span>
        </div>
        <div class="asset__text">
            <h2 class="asset__header">{{heading}}</h2>
            <p class="paragraph asset__paragraph" v-html="text">

            </p>
        </div>
    </div>
</template>

<script>
  export default {
    name: "BonusGridAsset",
    props: {
      imgSrc: String,
      text: String,
      heading: String
    }
  };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/globals";
    @import "~@bistudio/bohemia-vue-components/dist/scss/colors";

    .asset--wrapper {
        max-width: 400px;
        margin-bottom: 0px;
        padding-right: 28px;

        @media (max-width: $compact) {
            padding-right: 0;
        }
    }

    .asset__img {
        border-radius: 50%;
        background-image: linear-gradient(38deg, #00ba88 0%, #00b5f2 100%);
        width: 50px;
        height: 50px;
        text-align: center;
        float: left;
        position: relative;
        margin-right: 32px;

    }

    .asset__header {
        color: white;
        letter-spacing: 0.32px;
        font-family: 'Inter UI', sans-serif;
    }

    .asset__paragraph {
        word-wrap: break-word;
        max-width: 377px;
        margin: auto;
        margin-left: 0%;
        letter-spacing: 0.04em;
        text-align: left;
        line-height: 28px;
        color: white !important;


        /deep/ .heading-underline-animated-background {
            background-size: 0% 7px;
            background-image: linear-gradient(270deg, $cerulean, $cerulean);
            color: $cerulean;
            text-decoration: none;
            transition: all .4s ease-out;

        }

        &:hover {
            /deep/ .heading-underline-animated-background {
                background-size: 100% 7px;
                background-image: linear-gradient(270deg, $cerulean, $cerulean);
                color: white !important;
                text-decoration: none;
                transition: all .4s ease-out;
            }
        }
    }

    /deep/ .paragraph a {

        color: #00B5F2 !important;

    }

    .mono-numbers {
        font-family: $font-ibm-plex;
        color: white;
        font-size: 26px;
        position: absolute;
        top: 8px;
        left: 10px;
    }


</style>


// WEBPACK FOOTER //
// src/components/expatsPageComponents/BonusGridAsset.vue